<template lang="es">
    <v-card class="elevation-0">
      <v-card-text>
        
        <v-row class="text-center">
          <v-col cols="12" sm="4">
            <b>Tiempo en marcha:</b> {{tiempo_actual || ''}}
          </v-col> 
          <v-col cols="12" sm="4">
            <b>Tiempo restante: </b> {{tiempo_restante || ''}}
          </v-col> 
          <v-col cols="12" sm="4">
            <b>Fin según receta: </b> {{hora_finalizacion || ''}}
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
</template>
<script>
export default {
  props:{
    tiempo_actual:String,
    tiempo_restante:String,
    hora_finalizacion:String
  },
    data() {
      return {
      }
    },
}
</script>
<style>
    
</style>